import * as React from 'react';
import { AdminDashboardPageLayout } from '../../containers/AdminDashboardPageLayout';
import { SubadminsPage } from '../../containers/SubadminsPage';

export const AdminAccountSubadminsPage: React.FC = () => {
	return (
		<AdminDashboardPageLayout>
			<SubadminsPage />
		</AdminDashboardPageLayout>
	);
};
